module.exports = __webpack_public_path__ + "img/uk.a386e6a4.png";